var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('TopBar'),_c('Navbar',{attrs:{"routes":_vm.permissionMenus}}),_c('el-main',[_c('AppMain')],1),_c('FootBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }